module.exports = __webpack_public_path__ + "static/media/PipetteVector.1c418105.svg";